module.exports = __webpack_public_path__ + "static/media/selos.c4621326.png";